import React from "react";
import { useLocation } from "react-router-dom";
import styles from "./SelectedServiceSection.module.css";

const SelectedServiceSection: React.FC = () => {
  const location = useLocation();
  const selectedServiceName = location.state?.service || "سرویسی انتخاب نشده";

  return (
    <section className={styles.serviceContainer}>
      <header>
        <h1 className={styles.title}>سرویس انتخاب‌شده</h1>
      </header>

      <div className={styles.serviceItem}>
        <p className={styles.serviceName}>{selectedServiceName}</p>
      </div>

      <div className={styles.divider}></div>
    </section>
  );
};

export default SelectedServiceSection;
